import React from "react";
import Chart from "react-apexcharts";
import footprint from "../../../../assets/footprint-fill.png";
import { RiPinDistanceFill, RiFireLine } from "react-icons/ri";

type MetricType = "steps" | "distance" | "caloriesburned";

interface TeamPerformanceComparisonProps {
  selectedMetric: MetricType;
  onMetricChange: (metric: MetricType) => void;
  categories: string[];
  series: {
    name: string;
    data: number[];
  }[];
}

const TeamPerformanceComparison: React.FC<TeamPerformanceComparisonProps> = ({
  selectedMetric,
  onMetricChange,
  categories,
  series
}) => {
  const maxVal = Math.max(...series.flatMap(team => team.data));
  const computedMax = Math.ceil((maxVal * 1.1) / 10) * 10;

  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      height: 280,
      stacked: false,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
      labels: { style: { fontSize: '12px' } }
    },
    yaxis: {
      min: 0,
      title: {
        text: selectedMetric,
      },
      max: computedMax,
      tickAmount: 4,
      labels: {
        formatter: (val: number) =>
          Number.isInteger(val) ? val.toFixed(0) : Math.round(val).toFixed(0),
      },
    },
    legend: { show: true },
    tooltip: {
      shared: true,
      intersect: false,
    },
    colors: ["#094752", "#CAFFFD", "#3BAEA0", "#F25F5C"],
  };

  return (
    <div className="team-performance-comparison-container">
      <h5 className="goal-completion-title">Team Performance Comparison</h5>

      {/* Metric Toggle */}
      <div className="MetricToggleContainer">
        <div className="Metric-Icons">
          <button
            className={`GraphIcon ${selectedMetric === "steps" ? "active" : ""}`}
            onClick={() => onMetricChange("steps")}
          >
            <img src={footprint} alt="Steps" />
          </button>
          <button
            className={`GraphIcon ${selectedMetric === "distance" ? "active" : ""}`}
            onClick={() => onMetricChange("distance")}
          >
            <RiPinDistanceFill />
          </button>
          <button
            className={`GraphIcon ${selectedMetric === "caloriesburned" ? "active" : ""}`}
            onClick={() => onMetricChange("caloriesburned")}
          >
            <RiFireLine />
          </button>
        </div>
      </div>

      {/* Chart */}
      <Chart options={chartOptions} series={series} type="bar" height={280} />
    </div>
  );
};

export default TeamPerformanceComparison;
